
import React, { Fragment, useState, useEffect, useMemo } from "react";
import Breadcrumb from "../common/breadcrumb";
import { Modal, Button, Card, CardBody, CardHeader, Col, Container, Form, FormGroup, Input, Label, ModalBody, ModalFooter, ModalHeader, Row } from "reactstrap";
import DataTables from "../common/DataTables";
import { useDispatch, useSelector } from "react-redux";
import { GetCustomerList } from "../../redux/actions/SettingActions";
import moment from "moment/moment";

const CustomerList = () => {
    const dispatch = useDispatch()
    const [searchTerm, setSearchTerm] = useState("")

    const { CustomerListdata } = useSelector(state => state.settings)
    // console.log(CustomerListdata,"CustomerListdata")

    const Capitalize = (str) => {
        return str.charAt(0).toUpperCase() + str.slice(1);
    };

    // Filter customers based on search term
    const filteredCustomers = useMemo(() => {
        if (!CustomerListdata || !searchTerm) {
            return CustomerListdata || [];
        }

        return CustomerListdata.filter(customer => {
            const searchLower = searchTerm.toLowerCase();
            return (
                customer?.name?.toLowerCase().includes(searchLower) ||
                customer?.email?.toLowerCase().includes(searchLower) ||
                customer?.mobile?.toLowerCase().includes(searchLower) ||
                customer?.address?.area?.user_address?.toLowerCase().includes(searchLower) ||
                customer?.address?.area?.address?.toLowerCase().includes(searchLower) ||
                customer?.status?.toLowerCase().includes(searchLower)
            );
        });
    }, [CustomerListdata, searchTerm]);

    const handleSearchChange = (e) => {
        setSearchTerm(e.target.value);
    };
    var columns = [
        {
            name: <b>{Capitalize("S.No")}</b>,
            header: <b>{Capitalize("S.No")}</b>,
            width: "10%",
            cell: (row, index) => index + 1
        },
        {
            name: <b>{Capitalize("Registered On")}</b>,
            header: <b>{Capitalize("Registered On")}</b>,
            width: "10%",
            selector: row => moment(row?.created_at).format("DD-MM-YYYY"),
            style: {
                textAlign: "center",
            },
        },
        {
            name: <b>{Capitalize("Name")}</b>,
            header: <b>{Capitalize("Name")}</b>,
            selector: row => row?.name,
            style: {
                textAlign: "center",
            },
        },
        {
            name: <b>{Capitalize("Email")}</b>,
            header: <b>{Capitalize("Email")}</b>,
            selector: row => row?.email,
            style: {
                textAlign: "center",
            },
        },
        {
            name: <b>{Capitalize("Address")}</b>,
            header: <b>{Capitalize("Address")}</b>,
            width: "20%",
            selector: (row) => (
                <>
                    {row?.address?.area?.user_address || row?.address?.area?.address ? (<span>
                        {row?.address?.area?.user_address ? row?.address?.area?.user_address + row?.address?.area?.address : row?.address?.area?.address},
                    </span>) : "-"}
                </>

            ),
            style: {
                textAlign: "center",
            },
        },
        {
            name: <b>{Capitalize("Mobile")}</b>,
            header: <b>{Capitalize("Mobile")}</b>,
            selector: row => row?.mobile,
            style: {
                textAlign: "center",
            },
        },

        {
            name: <b>{Capitalize("status")}</b>,
            header: <b>{Capitalize("status")}</b>,
            width: "10%",
            selector: row => row?.status,
            style: {
                textAlign: "center",
            },
        },

    ];

    useEffect(() => {
        dispatch(GetCustomerList())
    }, [])

    return (
        <Fragment>
            <Breadcrumb title="Customer" parent="Products" />
            {/* <!-- Container-fluid starts--> */}
            <Container fluid="true">
                <Row>
                    <Col sm="12">
                        <Card>
                            <CardHeader>
                                <h5>Customer List</h5>
                            </CardHeader>
                            <CardBody>
                                <Row className="mb-3">
                                    <Col md="6">
                                        <div className="search-box">
                                            <Input
                                                type="text"
                                                className="form-control"
                                                placeholder="Search customers..."
                                                value={searchTerm}
                                                onChange={handleSearchChange}
                                            />
                                            {/* <i className="fa fa-search search-icon"></i> */}
                                        </div>
                                    </Col>
                                </Row>
                                <div className="clearfix"></div>
                                <div id="basicScenario" className="product-physical">
                                    {filteredCustomers && <DataTables
                                        columns={columns}
                                        row={filteredCustomers ? filteredCustomers : []}
                                    />}
                                </div>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </Container>

        </Fragment>
    )
}

export default CustomerList